import React, { useState, useEffect } from "react";
import "../App.css";
import "./PostComment.css";
import CommentForm from "./CommentForm.jsx";
import helpIcon from "../assets/delete.png";
import commentIcon from "../assets/comment.svg";
import like_icon from "../assets/Heart.png";
import { Link, useNavigate } from "react-router-dom";
import translations from "./translation.js";

const PostComment = ({ key, commentAuthor, postComment}) => {
    const [likes, setLikes] = useState(0);
    const [fileurl, setFileurl] = useState("");
    const [message, setMessage] = useState("");
    const [post, setPost] = useState({});
    const [reactions, setReactions] = useState([]);
    console.log("key:", postComment.id);
    const currentLanguage = localStorage.getItem("selectedLanguage") || "en";

    const comment = () => {
        if (sessionStorage.getItem("token")) {
            let url = process.env.REACT_APP_API_PATH + "/posts/"+ postComment.id;
      
            fetch(url, {
              method: "GET",
              headers: {
                "Content-Type": "application/json",
                Authorization: "Bearer " + sessionStorage.getItem("token"),
              },
            })
              .then((res) => res.json())
              .then((result) => {
                if (result) {
                    
                    setLikes(result.reactions.length);
                    setFileurl(result.attributes.fileURL);
                    setPost(result);
                    setReactions(result.reactions);
                    console.log("re", result);
                }
              })
              .catch((err) => {            
                console.log("ERROR loading posts");
              });
          }

    };
    const toggleHeart = () => {
      // const h = 
    };
  
    const showLike = () => {
      for (let i = 0; i < reactions.length; i++) {
        if (reactions[i].reactorID.toString() === sessionStorage.getItem("user")) {
          return (
            <img
              src={like_icon}
              className="comment-icon liked"
              onClick={(e) => tagPost("like", post.id)}
              alt="Remove Like"
            />
          );
        }
      }
      return (
        <img
          src={like_icon}
          className="comment-icon"
          onClick={(e) => tagPost("like", post.id)}
          alt="Remove Like"
        />
      )
    };
    const tagPost = () => {
        //find the appropriate reaction to delete - namely, the one from the current user
        let userReaction = -1;
        post.reactions.forEach((reaction) => {
          if (reaction.reactorID === parseInt(sessionStorage.getItem("user"))) {
            userReaction = reaction.id;
          }
        });
    
        // if there is one, delete it.
        if (userReaction >= 0) {
          //make the api call to post
          fetch(
            process.env.REACT_APP_API_PATH + "/post-reactions/" + userReaction,
            {
              method: "DELETE",
              headers: {
                "Content-Type": "application/json",
                Authorization: "Bearer " + sessionStorage.getItem("token"),
              },
            }
          ).then(
            (result) => {
                let newlikes = likes - 1;
                updatelikes(newlikes);
                setLikes(newlikes);
                setMessage(translations[currentLanguage].remove_like);
                setTimeout(setMessage, 3000, "");
            },
            (error) => {
              alert("error!" + error);
            }
          );
        } else {
          //make the api call to post
          fetch(process.env.REACT_APP_API_PATH + "/post-reactions", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer " + sessionStorage.getItem("token"),
            },
            body: JSON.stringify({
              reactorID: sessionStorage.getItem("user"),
              postID: postComment.id,
              name: "like",
            }),
          }).then(
            (result) => {
                
                let newlikes = likes + 1;
                updatelikes(newlikes);
                setLikes(newlikes);
                setMessage(translations[currentLanguage].like_comment);
                setTimeout(setMessage, 3000, "");
            },
            (error) => {
              alert("error!" + error);
            }
          );
        }
        
      };

    const updatelikes = async(newlikes) => {
        try {
            let url = process.env.REACT_APP_API_PATH + "/posts/"+ postComment.id;
            const userResponse = await fetch(url, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${sessionStorage.getItem("token")}`,
                },
            });
            console.log("in update likes");
            if (!userResponse.ok) {
                throw new Error('Failed to fetch user data');
            }
            
            const userData = await userResponse.json();
            const updatedAttributes = { ...userData.attributes, likes: newlikes};
            console.log("updatedAttributes:", updatedAttributes);
            console.log("likes:", newlikes);
            const patchResponse = await fetch(url, {
                method: "PATCH",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${sessionStorage.getItem("token")}`,
                },
                body: JSON.stringify({
                    attributes: updatedAttributes,
                }),
            });
    
            if (!patchResponse.ok) {
                throw new Error('Failed to update switch status');
            }
    
            const result = await patchResponse.json();
            console.log('Switch status updated successfully:', result);
            comment();
        } catch (error) {
            console.error('Error updating switch status:', error);
            alert("Failed to update switch status");
        }
    };
    
    useEffect(() => {
        comment();
    }, []);
    return (
        <div className="PC_comment" key={postComment.id}>
            
            <div className="PC_comment_author">{commentAuthor}:</div>
            <div className="PC_comment_text">{postComment.content}</div>
            <div className="PC_file">
                    {fileurl !== "" && <img src={fileurl} alt="picture"  className="PC_image_display"/>}
                </div>
            <div className="PC_likes" onClick={toggleHeart}>
                {showLike()}
                <h3>{likes}</h3>
                {message && (
                  <div className="PC_message">{message}</div>
              )}
            </div>
            
        </div>
    );
};

export default PostComment;